export default {
    data() {
        return {
            // 只存当前激活卡片唯一key，实现同一页面最多一个放大
            activeCardKey: ''
        }
    },
    methods: {
        isMobile() {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
        },
        /**
         * 切换卡片缩放（同一页面仅允许一个卡片放大）
         * @param {String|Number} uniqueKey 卡片唯一标识
         */
        toggleCardScale(uniqueKey) {
            // if (!this.isMobile()) return

            const key = String(uniqueKey)
            // 当前卡片已激活 → 取消缩放
            if (this.activeCardKey === key) {
                this.activeCardKey = ''
            } else {
                // 选中新卡片，自动清空上一个
                this.activeCardKey = key
            }
        },
        /** 判断当前卡片是否处于放大状态 */
        isCardScaled(uniqueKey) {
            return this.activeCardKey === String(uniqueKey)
        }
    },
    // 页面离开/组件销毁，清空缩放状态（需求2）
    beforeRouteLeave(to, from, next) {
        this.activeCardKey = ''
        next()
    },
    beforeDestroy() {
        this.activeCardKey = ''
    }
}


// WEBPACK FOOTER //
// ./src/mixin/cardScaleToggle.js